<template>
  <div
    class="ll-law-list-item"
    @click="listClick()"
  >
    <div
      class="ll-law-list-item_checkbox"
      @click.stop="cheboxClick()"
    >
      <LvTooltipButton
        :active="checkboxSelect"
        :active-tooltip-text="$t('取消收藏')"
        :tooltip-text="$t('收藏')"
        icon="icon-bookmark"
        active-icon="icon-bookmark-fill"
      />
    </div>
    <div class="ll-law-list-item_content">
      <div class="content_title-wrap">
        <p class="date">
          {{ date }}
        </p>
        <div class="title-wrap">
          <div class="title">
            {{ title }}
          </div>
          <div class="content-text">
            {{ content }}
          </div>
          <WsChips001
            class="mt-4"
            v-if="tags"
            :value="tags"
          />
        </div>
        <div
          v-if="badge"
          class="trailing-badge"
        >
          {{ badge }}
        </div>
        <div
          v-for="(badgeItem,badgeIndex) in badges"
          :key="badgeIndex"
          class="trailing-badge"
        >
          {{ badgeItem }}
        </div>
      </div>
    </div>
    <router-link
      :to="to"
      class="ll-law-list-item_router"
    />
  </div>
</template>
<script>
export default {
  name: "LlLawListItem",
  props: {
    to: {
      type: [String, Object],
    },
    date: {
      type: String,
      default() {
        return this.$t("無");
      },
    },
    title: {
      type: String,
      default: "",
    },
    badge: {
      type: String,
      default: "",
    },
    badges: {
      type: Array,
    },
    content: {
      type: String,
      default: "",
    },
    checkboxSelect: {
      type: Boolean,
      default: false,
    },
    tags: {
      type: Array,
    },
  },
  methods: {
    listClick() {
      this.$emit("click");
    },
    cheboxClick() {
      this.$emit("select");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/ll-law-list-item";
</style>